import React from "react";
import {Route} from "react-router-dom";

const module = (shopApp) => {
	const Withdrawal = shopApp.dynamic(() => import("./Withdrawal"));

	const url = "/withdrawal";

	let config = {
		name: "Withdrawal",
		routes: [
			<Route key={url} exact path={url} component={Withdrawal}/>
		]
	};

	shopApp.registerPage(config);

};

export default module;
